(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avh-bundle-shop"] && !Shopify.designMode) return;
  try {
    

function setupBundleShops(){
document.querySelectorAll('[data-bundle-shop]').forEach(root=>{
if(root.dataset.initialized)return;root.dataset.initialized='true';
const grid=root.querySelector('[data-bundle-grid]');
const seen=new Set();
[...grid.querySelectorAll('[data-bundle-card]')].sort((a,b)=>Number(a.dataset.rank)-Number(b.dataset.rank)).forEach(card=>{if(seen.has(card.dataset.product))card.remove();else{seen.add(card.dataset.product);grid.append(card)}});
const cards=[...grid.querySelectorAll('[data-bundle-card]')];
const patterns=[...root.querySelectorAll('button[data-texture]')], tiers=[...root.querySelectorAll('[data-tier-filter]')];
const motion=root.querySelector('[data-motion]'), reset=root.querySelector('[data-reset-pattern]');
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
let texture='all', tier='all', paused=reduced.matches, timer, hovering=false;
function show(){cards.forEach(card=>card.hidden=!((texture==='all'||card.dataset.texture===texture)&&(tier==='all'||card.dataset.tier===tier)));patterns.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.texture===texture)));tiers.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.tierFilter===tier)));reset.hidden=texture==='all';root.querySelector('[data-empty]').hidden=cards.some(c=>!c.hidden);grid.scrollTo({left:0,behavior:'instant'});}
function move(direction){const card=cards.find(c=>!c.hidden);if(!card)return;const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(grid).columnGap);const end=grid.scrollWidth-grid.clientWidth;let next=grid.scrollLeft+direction*step;if(direction>0&&grid.scrollLeft>=end-4)next=0;if(direction<0&&grid.scrollLeft<=4)next=end;grid.scrollTo({left:next,behavior:reduced.matches?'instant':'smooth'});}
function motionLabel(){motion.setAttribute('aria-pressed',String(paused));motion.setAttribute('aria-label',paused?motion.dataset.play:motion.dataset.pause);motion.textContent=paused?'▶':'Ⅱ';}
patterns.forEach(b=>b.addEventListener('click',()=>{texture=b.dataset.texture;show();root.querySelector('.avh-bundles__head').scrollIntoView({block:'start',behavior:reduced.matches?'instant':'smooth'})}));
tiers.forEach(b=>b.addEventListener('click',()=>{tier=b.dataset.tierFilter;show()}));
reset.addEventListener('click',()=>{texture='all';show()});
root.querySelector('[data-prev]').addEventListener('click',()=>move(-1));root.querySelector('[data-next]').addEventListener('click',()=>move(1));
motion.addEventListener('click',()=>{paused=!paused;motionLabel()});
root.addEventListener('mouseenter',()=>hovering=true);root.addEventListener('mouseleave',()=>hovering=false);
grid.addEventListener('pointerdown',()=>{paused=true;motionLabel()});
reduced.addEventListener('change',()=>{if(reduced.matches){paused=true;motionLabel()}});
timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return}const r=grid.getBoundingClientRect();if(!paused&&!hovering&&!document.hidden&&!root.contains(document.activeElement)&&r.bottom>0&&r.top<innerHeight)move(1)},6000);
show();motionLabel();
})}
setupBundleShops();document.addEventListener('shopify:section:load',setupBundleShops);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avh-fall-editorial"]) return;
  try {
    
function initAvhFall(scope) {
  scope.querySelectorAll('[data-fall-editorial]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const products = JSON.parse(root.querySelector('[data-fall-products]').textContent);
    const settings = JSON.parse(root.querySelector('[data-fall-settings]').textContent);
    const msg = JSON.parse(root.querySelector('[data-fall-messages]').textContent);
    const fallback = {bundle:{16:9845,18:10670,20:11495,22:12320},wig:{18:60500,22:99000,26:143000}};
    let mode = 'preorder', color = 'Espresso & Honey';
    const cards = [...root.querySelectorAll('[data-product]')];
    function variant(card) {
      const p = products[card.dataset.product];
      if (!p || !p.variants) return null;
      const length = card.querySelector('.avh-length').value + ' inches';
      return p.variants.find(v => v.option1 === color && v.option2 === length && v.option3 === (mode === 'preorder' ? 'Custom Preorder' : 'Ready to Ship'));
    }
    function validQuantity(card) {const n=Number(card.querySelector('.avh-qty').value);return Number.isInteger(n)&&n>=1&&n<=20;}
    function canBuy(v) {return !!v && v.available && (mode === 'preorder' || settings.released);}
    function render() {
      root.querySelector('#avh-mode-note').textContent = msg[mode === 'preorder' ? 'preorder_note' : 'ready_note'];
      cards.forEach(card => {
        const v=variant(card),type=card.dataset.product,button=card.querySelector('.avh-buy'),form=card.querySelector('form');
        const amount=v?v.price:fallback[type][card.querySelector('.avh-length').value]*(mode==='ready'?2:1);
        const currency=v?settings.currency:'USD';
        card.querySelector('.avh-price').textContent=new Intl.NumberFormat('en-US',{style:'currency',currency}).format(amount/100)+' '+currency;
        card.querySelector('.avh-selected-color').textContent=color;
        card.querySelector('.avh-price-type').textContent=msg[mode==='preorder'?'intro':'standard'];
        let status=mode==='preorder'?(v?(v.available?'made_to_order':'sold_out'):'preorder_opening'):(!settings.released?'not_released':v?(v.available?'available':'sold_out'):'ready_unavailable');
        if(!validQuantity(card))status='invalid';
        card.querySelector('.avh-status').textContent=msg[status];
        button.disabled=!canBuy(v)||!validQuantity(card)||form.dataset.busy==='true';
        button.textContent=button.disabled?msg[status]:msg[mode==='preorder'?'preorder_button':'ready_button'];
        form.querySelector('[name="id"]').value=v?v.id:'';
        const shipment=form.querySelector('[name="properties[Estimated shipment]"]');shipment.disabled=mode==='ready';
      });
    }
    root.querySelectorAll('[data-mode]').forEach(b=>b.addEventListener('click',()=>{mode=b.dataset.mode;root.querySelectorAll('[data-mode]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));render();}));
    root.querySelectorAll('[data-color]').forEach(b=>b.addEventListener('click',()=>{color=b.dataset.color;root.querySelectorAll('[data-color]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));root.querySelectorAll('.avh-art').forEach(x=>x.style.backgroundPositionY=b.dataset.row);render();}));
    cards.forEach(card=>{
      const form=card.querySelector('form');
      card.querySelector('.avh-length').addEventListener('change',render);
      card.querySelector('.avh-qty').addEventListener('input',render);
      form.addEventListener('submit',async e=>{
        e.preventDefault();const v=variant(card);if(form.dataset.busy==='true'||!canBuy(v)||!validQuantity(card))return;
        const button=card.querySelector('.avh-buy'),error=card.querySelector('[data-error]');error.textContent='';
        const data=new FormData(form);form.dataset.busy='true';button.disabled=true;button.textContent=msg.adding;
        try{const response=await fetch(settings.root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});const result=await response.json();if(!response.ok)throw new Error(result.description||msg.error);window.location.assign(settings.cart);}
        catch(err){error.textContent=err.message||msg.error;form.dataset.busy='false';render();}
      });
    });
    render();
  });
}
initAvhFall(document);
document.addEventListener('shopify:section:load',()=>initAvhFall(document));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeAvhStoryHeroes = (root = document) => {
    root.querySelectorAll('[data-avh-story-hero]').forEach((hero) => {
      if (hero.dataset.initialized === 'true') return;
      hero.dataset.initialized = 'true';

      const slides = [...hero.querySelectorAll('[data-story-slide]')];
      const tabs = [...hero.querySelectorAll('[data-story-tab]')];
      const previous = hero.querySelector('[data-story-previous]');
      const next = hero.querySelector('[data-story-next]');
      const pause = hero.querySelector('[data-story-pause]');
      let paused = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let current = 0;
      let timer;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', String(slideIndex !== current)));
        tabs.forEach((tab, tabIndex) => tab.setAttribute('aria-pressed', String(tabIndex === current)));
      };

      const stop = () => { window.clearInterval(timer); hero.querySelector('[aria-live]').setAttribute('aria-live', 'polite'); };
      pause.addEventListener('click', () => { paused = !paused; pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); pause.textContent = paused ? '▷' : 'Ⅱ'; if (paused) stop(); else start(); });
      const start = () => {
        stop();
        if (hero.dataset.autoplay === 'true' && !reducedMotion && !paused && !hero.matches(':hover') && !hero.contains(document.activeElement)) {
          hero.querySelector('[aria-live]').setAttribute('aria-live', 'off');
          timer = window.setInterval(() => show(current + 1), Number(hero.dataset.interval));
        }
      };

      tabs.forEach((tab, index) => tab.addEventListener('click', () => {
        show(index);
        start();
      }));
      previous.addEventListener('click', () => {
        show(current - 1);
        start();
      });
      next.addEventListener('click', () => {
        show(current + 1);
        start();
      });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', () => window.setTimeout(start, 0));
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      start();
    });
  };

  initializeAvhStoryHeroes();
  document.addEventListener('shopify:section:load', (event) => initializeAvhStoryHeroes(event.target));

  } catch(e) { console.error(e); }
})();
})();
